import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const updateSelectedDate = (date: Types.SelectedDate) =>
  ({type: Constants.UPCOMING_SCHEDULES_UPDATE_SELECTED_DATE, date})

export const fetchUpcomingSchedules = (community: string, startDate: string, endDate: string) =>
  Request.requestActionCreator(Constants.FETCH_UPCOMING_SCHEDULES)
  ({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/date/${startDate}?end_date=${endDate}`,
  })



// WEBPACK FOOTER //
// ./src/pages/upcoming-schedules/actions.ts